import { render, staticRenderFns } from "./DatesList.vue?vue&type=template&id=06d65e4d&scoped=true"
import script from "./DatesList.vue?vue&type=script&lang=js"
export * from "./DatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d65e4d",
  null
  
)

export default component.exports